/* global Cookies */

"use strict";

const keyName = "session-token.provider";
const oldKeyName = "hint.session-token.provider";
let cookieManager = null;

module.exports = {
  initialize: function (cm) {
    cookieManager = cm;
  },
  set: function (value) {
    // Clean up old cookie name without prefix (migration)
    Cookies.remove(oldKeyName);
    Cookies.remove(oldKeyName, { domain: cookieManager.customPolicy.domain });
    return cookieManager.store(keyName, value);
  },
  load: function () {
    // Try new prefixed name first, fall back to old name for migration
    return cookieManager.retrieve(keyName) || Cookies.get(oldKeyName);
  },
  remove: function () {
    // Remove both old and new cookie names
    Cookies.remove(oldKeyName);
    Cookies.remove(oldKeyName, { domain: cookieManager.customPolicy.domain });
    return cookieManager.remove(keyName);
  },
};
